(() => {
  'use strict';

  /**
   * Atributos accesibles defensivos para controles que apps/bloques antiguos
   * puedan inyectar sin nombre accesible. No reemplaza el marcado correcto,
   * pero evita botones de cerrar anónimos en el buscador actual.
   */
  const searchClose = document.querySelector('.btn--close-search');
  if (searchClose && !searchClose.getAttribute('aria-label')) {
    searchClose.setAttribute('aria-label', 'Cerrar buscador');
  }
})();

/* Acción AJAX compartida de las cards MBO (solo productos de variante única). */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mbo-card-add]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  const card = button.closest('.grid-product, .cmb-card') || button.parentElement;
  card.querySelector('.mbo-card-feedback')?.remove();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(window.Shopify?.routes?.root
      ? `${window.Shopify.routes.root}cart/add.js`
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload.description || 'No se pudo agregar el producto.');
    }

    const item = await response.json();
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
  } catch (error) {
    console.error('[MBO card add]', error);
    const message = document.createElement('p');
    message.className = 'mbo-card-feedback';
    message.setAttribute('role', 'alert');
    message.textContent = error.message || 'No se pudo agregar el producto';
    card.appendChild(message);
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
